/**
 * Copyright (c) 2025, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import IdentityHeader from "./IdentityHeader";
import PayoutAlert from "./PayoutAlert";
import PlugOnlyNote from "./PlugOnlyNote";
import ProfileNudge from "./ProfileNudge";
import StatsBoard from "./StatsBoard";
import "./NonprofitDashboard.css";

// Nonprofit · "you". The month, where it came from, and the gifts behind it.
// For a signed-in organisation every figure here is its own Plug payments;
// CheckPlus donations are filtered out server-side and again on the way in.
class NonprofitDashboard extends Component {
  render() {
    const vm = this.props.vm;
    const d = vm.dash;
    if (d.loading || d.error) {
      return <div className="Marketplace-card Marketplace-status">{d.error ? vm.m.dashError : vm.m.dashLoading}</div>;
    }
    return (
      <div className="Marketplace-Dash">
        {/* Above the nudge: an organisation that cannot be paid has a bigger
            problem than an unanswered profile question. */}
        <PayoutAlert alert={vm.payoutAlert} />
        <ProfileNudge nudge={vm.profileNudge} />
        {/* Last of the three, and directly above the figures it is about:
            what this page counts, and where the rest of it is kept. */}
        <PlugOnlyNote note={vm.plugOnlyNote} />
        {/* Who the organisation is, above the figures rather than among
            them. Null on the sample dashboard and before the profile is
            read — a band naming nobody is worse than no band. The same
            component draws the donor's. */}
        <IdentityHeader profile={d.profile} />
        <StatsBoard data={d} m={vm.m} />
        <div className="Marketplace-card">
          <div className="Marketplace-cardHead">
            <span className="Marketplace-cardTitle">{vm.m.recentTitle}</span>
            <span className="Marketplace-link" onClick={d.goSupporters}>
              {vm.m.recentSeeAll}
            </span>
          </div>
          {/* Two ways to have no transactions: none yet, or none possible yet
              — an organisation waiting on approval cannot receive on Plug at
              all, and telling it to look in CheckPlus would be answering a
              question it has not asked. */}
          {d.isEmpty && (
            <div className="Marketplace-empty">{d.notLive ? vm.m.dashNotLive : vm.m.dashEmpty}</div>
          )}
          <div className="Marketplace-Dash-gifts">
            {d.recent.map((g) => (
              <div className="Marketplace-Dash-gift" key={g.id}>
                <div className="Marketplace-Dash-giftMono" style={{ background: g.tint, color: g.color }}>
                  {g.mono}
                </div>
                <div className="Marketplace-Dash-giftInfo">
                  <div className="Marketplace-Dash-giftWho">{g.who}</div>
                  <div className="Marketplace-Dash-giftKind">
                    {g.kind}
                    {g.share ? " · " + g.share : ""}
                  </div>
                </div>
                <span className="Marketplace-Dash-giftWhen">{g.when}</span>
                <span className="Marketplace-Dash-giftAmount">{g.amount}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

NonprofitDashboard.propTypes = {
  vm: PropTypes.object.isRequired,
};

export default NonprofitDashboard;
